import { render, staticRenderFns } from "./CheckoutRetention.vue?vue&type=template&id=71aff366&scoped=true&"
import script from "./CheckoutRetention.vue?vue&type=script&lang=js&"
export * from "./CheckoutRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aff366",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonDialog: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/CommonDialog.vue').default})
